<button type="button" class="mobile-search-item__link d-block w-100 fw-light fs-18 bg-transparent border-0 text-start p-0 text-white" (click)="clickEvent.emit($event)">
    <span class="fw-normal">{{ disease.name }}</span>
    <span class="synonym mobile-search-item__match-context fs-7 fw-light" *ngIf="disease.synonymString">
        <span>Other names: </span><span>{{ disease.synonymString }}</span>
    </span>
</button>
